export default __webpack_public_path__ + "static/media/articles-header-icon.77847919.svg";